import type { FromModel } from "@/__main__/data-model.mjs";
import createModel, { Mapped, Tuple } from "@/__main__/data-model.mjs";
import getMapName from "@/game-eft/utils/get-map-name.mjs";

export const EFTWeaponImages = createModel(
  Mapped({ key: String, value: String }),
);

const afterTransformModel = Mapped({
  key: String,
  value: { label: Tuple([String, String]), fileName: String, key: String },
});

export const EFTMapImages = createModel(
  Mapped({ key: String, value: String }),
).transform(afterTransformModel, (response) => {
  const result: FromModel<typeof afterTransformModel> = {};

  for (const key in response) {
    result[key] = {
      key,
      label: getMapName(key),
      fileName: response[key],
    };
  }

  return result;
});

export type EFTMapImgs = FromModel<typeof EFTMapImages>;
